import React from 'react';
import ProviderHeader from './common/header';
import ProviderSidebar from './common/sidebar';
import ProvidersRoutes from './providers.routes';

const Providers = () => {
  return (
    <>
      
        <ProviderHeader />
        <ProviderSidebar />
      <ProvidersRoutes />
    </>
  );
};

export default Providers;
